// Handlebars "wrapper" is used by frontend code. It contains all helpers.
// This runs in a browser / webpacked environment
// TODO: Once all templates are precompiled, this file should use handlebars/runtime

/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars'; // from vendor/lib

import './handlebars/handle-url';
import './handlebars/helper-date';
import './handlebars/helper-i18n';
import './handlebars/helper-img';
import './handlebars/helper-markdown';
import './handlebars/helper-xsrfTokenInput';

export default Handlebars;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars-wrapper.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars-wrapper.js